export default {"src":"/_next/static/media/match.b0845968.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};